import React from 'react'
import { stripHtml } from 'string-strip-html'
// import { checkTextTranslation } from '../../utils/useful'
import formulaEvaluator from "../../utils/formulaParser";
import formulaColumnsParser from "../../utils/formulaColumnsParser";

import { checkVariablesListForValue, getObject, priceStandardView, translate } from '../../utils/useful';
import moment from 'jalali-moment';

class TableFormulaInput extends React.Component {
    state = {
    }

    componentDidMount() {

        this.createData()

        // console.log(formulaEvaluator.evaluate('DATEDIFF(DATEADD(DATEADD(NOW(), -2, "day"), -4, "hour"), NOW(), "hour")'))
        // console.log(formulaEvaluator.evaluate('INT(DATEDIFF(DATEADD(DATEADD(NOW(), -2, "day"), -4, "hour"), NOW(), "hour") / 24) + " days and " + MOD(DATEDIFF(DATEADD(DATEADD(NOW(), -2, "day"), -4, "hour"), NOW(), "hour"), 24) + " hours"'))
        // console.log(formulaEvaluator.evaluate(`LET(diff, DATEDIFF(DATEADD(NOW(), -2, "days"), NOW(), "hour"), INT(ABS(diff) / 24))`))
        // 'INT(DATEDIFF([StartDate], NOW(), "hour") / 24) & " days and " & MOD(DATEDIFF([StartDate], NOW(), "hour"), 24) & " hours"'
        // console.log(formulaEvaluator.evaluate(`FOR("i", 1, 5, i * 2)`))
    }

    componentDidUpdate(prevProps) {
        if (prevProps.fullData != this.props.fullData) {
            this.createData()
        }
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    createData = () => {

        let finalData

        if (this.props.data != null) {

            finalData = this.props.data

        } else {

            let info = this.props.header?.information
            if (Array.isArray(this.props.params) && info.formula) {
                let formula = stripHtml(info.formula).result
                for (let i = 0; i < this.props.params.length; i++) {
                    const param = this.props.params[i];
                    // console.log('param',param?.info, data, param?.fields, param?.label)
                    finalData = this.textVariableReplacer(param?.info, formula, param?.fields, param?.label)
                    // console.log(data)

                }
            }

            // console.log(finalData)

            finalData = formulaEvaluator.evaluate(finalData, this.props.fullData)
            // console.log(finalData)

            // this.setState({ data: finalData })
            // console.log(finalData)
        }

        this.setState({ data: finalData })

    }


    textVariableReplacer = (data, content, fields, preLabel) => {

        // console.log('data', content, data)
        if (content && typeof content == 'string') {

            let output = content

            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = content.match(reg)
            if (matches) {

                // console.log('matches', matches)
                for (let index = 0; index < matches.length; index++) {
                    const match = matches[index];


                    let key = match.replace(/{/g, '').replace(/}/g, '')
                    let found


                    // console.log('keyis', key)
                    // console.log('fields', fields)
                    if (fields) {

                        for (let j = 0; j < fields.length; j++) {
                            const header = fields[j];

                            let label = header.information?.label
                            if (typeof label == 'string' && label.includes('{{lang}}')) {
                                label = header.information?.label.replace('{{lang}}', '')
                            }

                            if (preLabel) {
                                label = preLabel + ' - ' + label
                            }

                            // console.log('preLabel', label)

                            let headerLabel = header.information?.label
                            if (typeof headerLabel == 'string' && headerLabel.includes('{{lang}}')) {
                                headerLabel = header.information?.label.replace('{{lang}}', '')
                            }
                            // headerLabel
                            if (key == headerLabel || key == label || key == header.key) {

                                found = true
                                // console.log("FOUND", data, header.key)

                                let value = getObject(data, header.key)
                                if (value == null) {
                                    value = getObject(data, 'values.' + header.key)
                                }

                                if (value == null) {
                                    value = getObject(this.props.fullData, header.key)
                                }

                                if (value == null) {
                                    value = getObject(this.props.fullData, 'values.' + header.key)
                                }


                                // console.log(value)

                                if (value != null) {


                                    value = this.convertValueToStringFormat(value, header)


                                    let nreg = new RegExp(match, 'g')
                                    output = output.replace(nreg, value)
                                } else {
                                    let nreg = new RegExp(match, 'g')
                                    output = output.replace(nreg, '')
                                }

                            }


                        }
                    }

                    // console.log("output",found, output)
                    if (!found) {

                        // console.log('key', key)

                        let foundInParams = checkVariablesListForValue(this.props.params, key, ' - ')

                        if (foundInParams?.data) {
                            let value = this.convertValueToStringFormat(foundInParams?.data, foundInParams?.field)

                            let nreg = new RegExp(match, 'g')
                            output = output.replace(nreg, value)
                        }
                        // console.log('foundInParams', foundInParams)
                    }
                }
            }

            return output

        }

    }





    convertValueToStringFormat = (value, field) => {


        switch (field.type) {
            case "PriceInput":
                // value = priceStandardView(value)
                break;

            case "NumberInput":
                // value = priceStandardView(value)
                break;

            // case "PhoneInput":
            //     value = phoneStandardView(value)
            //     break;



            case "AddressInput":
                value = `${value?.address} ${value?.address2} ${value?.city} ${value?.cashed?.state?.title} ${value?.cashed?.country?.title} ${value?.zipCode}`
                break;

            case "DateInput":
                let format = 'DD MMM YYYY'
                // console.log(this.props.variables)
                if (this.props.variables?.appletSettings?.calendarType == 'jalali') {
                    format = 'jYYYY/jM/jD'
                }
                if (field.information?.showHour) {
                    format = format + ' hh:mm'
                }

                let tempValue = isNaN(value) ? value : Number(value)

                if (moment(tempValue).isValid()) {
                    value = moment(tempValue).format(format)
                } else {
                    value = translate('Invalid date')
                }
                break;

            case "DateTimeInput":
                let mformat = 'DD MMM YYYY'
                if (field.information?.showHour) {
                    mformat = mformat + ' hh:mm'
                }
                if (moment(Number(this.props.data)).isValid()) {

                }
                value = moment(Number(value)).format(mformat)
                break;


            default:
                value = value ? String(value) : null;
        }

        if (!isNaN(Number(value))) {
            value = Number(value)
        }

        return value

    }


    render() {
        let styleInfo = this.props.styleInfo
        let info = this.props.header?.information

        return (
            <div className="w-100 h-100 flexcc">
                {(this.props.fullData && info.formula) && (
                    // <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{String(this.props.data)}</p>
                    <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }}>{this.state.data}</p>
                )}
            </div>
        )
    }
}

export default TableFormulaInput;